<template>
    <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="10" md="8" lg="6" xl="5">
                <v-card class="elevation-12">
                    <v-row class="h-50 logo" v-if="!loading">
                        <v-col cols="12">
                            <router-link to="/">
                                <v-img src="/console/theme/images/logo-small.png"
                                       width="101"
                                       class="ml-3"></v-img>
                            </router-link>
                        </v-col>
                    </v-row>
                    <slot></slot>
                    <v-row v-if="pinSwitch">
                        <v-col cols="12" class="text-center">
                            <v-chip
                                    color="primary darken-4"
                                    close
                                    outlined
                                    @click:close="disablePinSwitch"
                            >Quick pin switch enabled
                            </v-chip>
                        </v-col>
                    </v-row>
                    <gappt-footer v-if="!loading"></gappt-footer>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="this.connectionError" persistent max-width="450">
            <v-card>
                <v-card-title class="headline">Connection problem</v-card-title>
                <v-card-text>
                    Something goes wrong whilst trying to connect to server.<br/>
                    Please check your internet connection.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="black" outlined @click="connectionError = false">Try again</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>

</template>

<script>
    import GapptFooter from "./Footer";
    import EventBus from '../event-bus';

    export default {
        name: "login-layout",
        components: {GapptFooter},
        data() {
            return {
                connectionError: false
            }
        },
        computed: {
            loading() {
                return this.$store.state.loading
            },
            pinSwitch() {
                return !!this.$pinSwitchService.get();
            }
        },
        methods: {
            disablePinSwitch() {
                this.$router.replace({name: "pin-switch"});
            }
        },
        mounted() {
            EventBus.$on('apiConnectionError', () => {
                this.connectionError = true;
            });
        }
    }
</script>

<style scoped>

</style>
